import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const PartnerBinsRoutes: Routes = [
  {
    path: "partner-bins",
    loadComponent: () =>
      import("./partner-bins/partner-bins.component").then(
        (m) => m.PartnerBinsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./partner-bins-list/partner-bins-list.component").then(
            (m) => m.PartnerBinsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./partner-bins-form/partner-bins-form.component").then(
            (m) => m.PartnerBinsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./partner-bins-form/partner-bins-form.component").then(
            (m) => m.PartnerBinsFormComponent,
          ),
      },
    ],
  },
];
